export default __webpack_public_path__ + "static/media/not-found.024e787a.png";